import { createFeatureSelector } from '@ngrx/store'
import { INotificationsState } from '@adex/shared/models/states/notifications.state'
import { notificationsEntityAdapter } from '@adex/store/adapters'


const selectState = createFeatureSelector<INotificationsState>('notificationsState')
export const {
  selectAll: selectNotificationsData,
  selectEntities: selectNotificationsArrayMap
} = notificationsEntityAdapter.getSelectors(selectState)
